import { lazy } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'

const ReturSisaWipPage = lazy(() => import('./pages/retur-sisa-wip'))
const KirimAntarGudangPage = lazy(() => import('./pages/kirim-antar-gudang'))
const DetailTransferPage = lazy(() => import('./pages/detail-transfer'))
const DetailReturTembakauPage = lazy(() => import('./pages/detail-retur-tembakau'))

const PICKING_TRANSFER = '/solutions/wms/request-production/picking-rm-operator?tab=transfer'
const TRANSFER = '/solutions/wms/wip-transfer/kirim-antar-gudang'
const WIP_TOBACCO = '/solutions/wms/wip-transfer/retur-sisa-wip?tab=tembakau'

/**
 * Cluster C07 WIP & Transfer Antar Gudang — WIP-01 (retur-sisa-wip, detail tembakau retur-sisa-wip/tembakau/:id), TRF-01 (kirim-antar-gudang),
 * TRF-01A (kirim-antar-gudang/:id). Stub redirect mengikuti BA 12C / prototype v7.44 (laporan 11, 22):
 * WIP-02 → WIP-01?tab=tembakau, TRF-02 → REQ-03?tab=transfer, TRF-03 / TRF-04 → TRF-01. Putaway retur WIP
 * dikerjakan operator di IRM-07 (tugas putaway PWR), pengambilan transfer di REQ-03 tab Transfer.
 */
const wipTransferRoutes: RouteObject[] = [
  {
    path: 'wip-transfer',
    children: [
      {
        path: 'retur-sisa-wip',
        children: [
          { index: true, element: <ReturSisaWipPage /> },
          {
            // Detail retur tembakau = halaman; "Back" (`..`) kembali ke tab Tembakau lewat index ini.
            path: 'tembakau',
            children: [
              { index: true, element: <Navigate to={WIP_TOBACCO} replace /> },
              { path: ':id', element: <DetailReturTembakauPage /> }
            ]
          }
        ]
      },
      {
        path: 'kirim-antar-gudang',
        children: [
          { index: true, element: <KirimAntarGudangPage /> },
          { path: ':id', element: <DetailTransferPage /> }
        ]
      },
      { path: 'retur-tembakau', element: <Navigate to={WIP_TOBACCO} replace /> },
      { path: 'putaway-retur-wip', element: <Navigate to={WIP_TOBACCO} replace /> },
      { path: 'pengambilan-transfer', element: <Navigate to={PICKING_TRANSFER} replace /> },
      { path: 'picking-transfer', element: <Navigate to={PICKING_TRANSFER} replace /> },
      { path: 'surat-jalan-internal', element: <Navigate to={TRANSFER} replace /> },
      { path: 'staging-transfer', element: <Navigate to={TRANSFER} replace /> },
      { path: 'penerimaan-transfer', element: <Navigate to={TRANSFER} replace /> },
      { path: 'terima-transfer', element: <Navigate to={TRANSFER} replace /> }
    ]
  }
]

export default wipTransferRoutes
